import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom";
import OAuthCardLayout from "./OAuthCardLayout";
import { Card, CardBody, Col, Row } from "reactstrap";
import SikkaInput from "../../common/SikkaInput";
import { useForm } from "react-hook-form";
import { Button, Form, FormGroup } from "react-bootstrap";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import axios from "axios";
import apiURL from "../../../services/apiURL";
import { toast } from "react-toastify";
import Loader from "../../common/Loader";
import Section from "../../common/Section";
import { ip } from "../../../services/apiCall";
import { useHistory } from "react-router";
const API_URL = apiURL("authentication")


const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
const AuthAppLayout = () => {
  const { register, handleSubmit, errors, watch } = useForm();
  const [oauthMeta, setOAuthMeta] = useState(null);
  const [partnerEmail,setPartnerEmail] =useState("")
  const [isDisabled, setIsDisabled] = useState(false);
  const [appName,setAppName] =useState("")
  const history = useHistory();
  const query = useQuery();
  var appid = query.get("client_id");
  var scope = query.get("scope");
  var state = query.get("state");
  var return_path = query.get("redirect_uri");
  var response_type = query.get("response_type");
  const fetchOauthPartnerAuthenticationData = (body) => {
    axios
        .post(`${API_URL}oauth_partner_authentication`, body)
        .then((res) => {
          setError(null)
          setOAuthMeta(res.data.items); 
          setPartnerEmail(res.data.items.partner_emailid) 
          setAppName(res.data.items.app_name)
          if(res.data.items.app_status !="verified")
          {
            setError({
              message:"Unauthorized access"
            })
          }
        })
        .catch((error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          toast.error(resMessage);
          setError({
            message:resMessage
          })
          // toast.warning(error.response.data.long_message + " " + error.response.data.more_information);
        });
    
  };
  const [error, setError] = useState(true);

  const [loader, showLoader, hideLoader] = useFullPageLoader();

 
  useMemo(() => {
    var data={
      "app_id":appid,
      "response_type":response_type,
      "state":state,
      "return_path":return_path,
      "scope":scope
    };
    if (appid != "" && appid != null) {
      if (scope != "" && scope != null) {
        if (response_type != "" && response_type != null) 
        {
        if (state != "" && state != null) {
          if (return_path != "" && return_path != null) {
            fetchOauthPartnerAuthenticationData(data)
          }
          else{
            setError({
              message: "Missing Redirect URl",
            })
          }
        }
        else{
          setError({
            message: "Missing State",
          })
        }
       }
       else{
        setError({
          message: "Missing Response Type",
        })
      }
      }
      else{
        setError({
          message: "Missing Scope",
        })
      }
    }
    else{
      setError({
        message: "Missing Client Id",
      })
    }
  }, [])
  
  
  const fetchOauthUserAuthentication = (data) => {
    var app_id = query.get("client_id");
    setIsDisabled(true)
    axios
    .post(`${API_URL}oauth_user_authentication`, data)
    .then((res) => {
      var data=res.data.items;
      history.push({
        pathname: `${process.env.PUBLIC_URL}/oauth/authappresult`,
        state: { 
          master_customer_id: data.master_customer_id,
          po_user_name:data.po_user_name,
          app_id:app_id,
          client_email:partnerEmail,
          return_path:return_path,
          app_name:appName,
          state:state,
         }
      });
    setIsDisabled(false)
    })
    .catch((error) => {
    setIsDisabled(false)
      const resMessage =
        (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        if(error.status=401){
      toast.error(resMessage);}
      else{
        setError({
          message:resMessage
        })
      }      
    });
  };

  const onSubmit = (data) => {    
    var data={
      "email_id":data.email,
      "password":data.password,
      "ip_address":ip,
      "web_url":window.location.href
    };
    fetchOauthUserAuthentication(data)
  };

  return (
    <div>
     <OAuthCardLayout url={oauthMeta?.app_logo} name={oauthMeta?.partner_name}>
        <Row
          className="flex-center w-100 max-width-705 oauth-container"
          style={{ opacity: error ? 0.5 : 1 }}
        >
          <Col>
            <div className="d-flex flex-column rounded w-100 oauth-info-container">
              <Row>
                <Row className="w-100 m-0">
                  <span className="oauth-text-bold oauth-list-title w-100 pl-4 pr-4 p-2">
                    {"This app would like to access your practice data:"}
                  </span>
                </Row>
                <Row className="w-100 m-0 pl-0 max-vh--25">
                  <ul className="oauth-access-list">
                    {oauthMeta &&
                      oauthMeta.access_list &&
                      oauthMeta.access_list[0].allowed_api_list ? (
                      oauthMeta.access_list[0].allowed_api_list
                        .split(",")
                        .map((value, index) => {
                          return (
                            <li key={index} style={{ color: "#00d27a" }}>
                              {value}
                            </li>
                          );
                        })
                    ) : (
                      <></>
                      // <li style={{ color: "#00d27a" }}>None</li>
                    )}
                  </ul>
                </Row>
              </Row>
              <span className="border-top w-100 pl-4 pr-4 mb-4 mt-4" />
              <Row>
                <Row className="w-100 m-0">
                  <span className="oauth-text-bold oauth-list-title w-100 pl-4 pr-4">
                    {"This app will not be able to:"}
                  </span>
                </Row>
                <Row className="w-100 m-0 pl-0">
                  <ul className="oauth-access-list">
                    <li>{"Access your password"}</li>
                  </ul>
                </Row>
              </Row>
            </div>
          </Col>
          <Col className="border-left border-gray oauth-credentials-column">
            <Row className="flex-column w-100 m-0 flex-center pt-3">
              <p className="oauth-text-bold opacity-90 fs-0 fw-bold">
                Authorize Integration With Your Sikka Account
              </p>
              <Form
                onSubmit={handleSubmit((data) => onSubmit(data))}
                className="d-flex w-100 flex-center flex-column"
              >
                <Row className="w-100 flex-column oauth-credentials-container">
                  <SikkaInput
                    label="Email"
                    placeholder="Email"
                    id="email"
                    name="email"
                    innerRef={register({
                      required: "Email is required"
                    })}
                    disabled={!query.get("client_id") || error}
                    errors={errors}
                  />
                  <SikkaInput
                    label="Password"
                    placeholder={"Password"}
                    onChange={({ target }) => { }}
                    type="password"
                    id="password"
                    name={"password"}
                    innerRef={register({
                      required: "Password is required",
                    })}
                    disabled={!query.get("client_id") || error}
                    errors={errors}
                  />
                </Row>
                <Row className="d-flex col-11 justify-content-center oauth-credentials-container pl-pr-10">
                  <FormGroup>
                    <Button
                      color="primary"
                      type="submit"
                      name="Submit"
                      className="pl-pr-2 fs--1"
                      disabled={(!query.get("client_id") || error) || isDisabled}
                    >
                      Authorize App
                    </Button>
                  </FormGroup>
                </Row>
              </Form>
            </Row>
            <a 
            className="cursor-pointer d-block link-primary"
              onClick={()=>{
                  window.location.href ="https://account.sikka.ai/ForgotPass";
              }}
            >
              <p className="d-flex fs--1 w-100 flex-center p-2">
                Forgot Your Password?
              </p>
            </a>
            <div className="d-flex flex-row flex-center">
              <p className="fs--1 fw-bold">Don't have an account?</p>
              <a 
              className="cursor-pointer d-block link-primary"
              onClick={()=>{
                if(oauthMeta.sign_up_link ==""){
                  toast.error("Your application is not publish yet. For more details contact SIKKA Support.");
                }
                else{
                  window.location.href = oauthMeta.sign_up_link;
                }
              }}>
                <p className="d-flex fs--1 w-100 flex-center p-2">Sign Up</p>
              </a>
            </div>
          </Col>
        </Row>
        {error && error.message && (
          <Row>
            <p className="m-4" style={{ color: "red" }}>
              {error.message}
            </p>
          </Row>
        )}
      </OAuthCardLayout>
    </div>
  );
};

export default AuthAppLayout;
